import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Card, Col, Row } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BASE_URL } from '../../../services/Api';
import { authHeader } from '../../../services/auth-header';  
import MDPOTOIConvert from '../ManufacturingDomestic/Convert';

function MRNTOIMDConvert() {  
  const navigate = useNavigate();
  const { pointindex, id } = useParams();
  const [potype, setpotype] = useState('');
  const [pocategory, setpocategory] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}purchaseOrder/findById/${id}`, {
          headers: authHeader(),
        });
        setpotype(response.data.potype);
        setpocategory(response.data.pocategory);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [id]);

  const renderPageDisplay = () => {
    if (potype === 'Manufacturing') {
      return <MDPOTOIConvert />;
    }
    return null;
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>CONVERT PO TO INSPECTION</h6>
          <div className="view-buttons">
            <Link to={`/poindex/1`}>
              <button className="button-70">BACK</button>
            </Link>
          </div>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select a Product Type:</Form.Label>
                <Form.Select disabled value={potype}>
                  <option value="">--Please choose an option--</option>
                  <option value="Manufacturing">Manufacturing</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select a Product Category:</Form.Label>
                <Form.Select disabled value={pocategory}>
                  <option value="">--Please choose an option--</option>
                  <option value="Domestic">Domestic</option>
                  <option value="International">International</option>
                </Form.Select>
              </Form.Group>
            </Col>
            {renderPageDisplay()}
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
}

export default MRNTOIMDConvert;
